export default function LegalPage({ title, intro, sections }) {
  return (
    <main className="page-shell">
      <div className="page-narrow">
        <div className="surface-card px-8 py-10 md:px-10 md:py-12">
          <p className="eyebrow">Encreage</p>
          <h1 className="mt-6 font-display text-5xl leading-none tracking-tight text-slate-900">{title}</h1>
          <p className="mt-6 max-w-2xl text-base leading-8 text-slate-600">{intro}</p>

          <div className="mt-12 space-y-10">
            {sections.map((section) => (
              <section key={section.heading} className="section-divider pt-8 first:border-t-0 first:pt-0">
                <h2 className="mb-3 text-xl font-medium text-slate-900">{section.heading}</h2>
                <div className="space-y-3">
                  {section.body.map((paragraph) => (
                    <p key={paragraph} className="leading-8 text-slate-700">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
}
